import type { ReactNode } from 'react';
import { classNames } from '@library/utils';

export interface WithdrawalsCellProps {
  children: ReactNode;
  className?: string;
  hideOnSmallScreen?: boolean;
  sortable?: boolean;
}

export const WithdrawalsCell = ({
  children,
  className = '',
  hideOnSmallScreen = false,
  sortable = false
}: WithdrawalsCellProps) => {
  return (
    <td
      className={classNames(
        'whitespace-nowrap py-1 pl-1 lg:pl-2',
        hideOnSmallScreen ? 'hidden md:table-cell' : '',
        sortable ? '2xl:pr-9' : '',
        className
      )}
    >
      {children}
    </td>
  );
};
